import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

// Short-lived signed URL for a feedback row's viewport screenshot (private S3
// object); null when the row has no screenshot.
export const getProductFeedbackScreenshotUrl = unaryRpc({
  name: "getProductFeedbackScreenshotUrl" as const,
  input: z.object({
    // Numeric string for a CRDB bigint PK; the handler feeds it to BigInt(),
    // so reject non-numeric values here as a 400 instead of a server error.
    id: z.string().regex(/^\d+$/, "id must be a numeric string"),
  }),
  output: z.object({ url: z.string().nullable() }),
});
